import { COLORS } from "../assets/theme";

export const getDisabledActionProps = (row: any, actionConfig: any) => {
  const isDisabled =
    typeof actionConfig.isDisabled === "function"
      ? actionConfig.isDisabled(row)
      : actionConfig.isDisabled || false;

  return {
    disabled: isDisabled,
    color: isDisabled ? "#D3D3D3" : COLORS.MainColor,
    stroke: isDisabled ? "#D3D3D3" : COLORS.MainColor,
  };
};

export const findServiceDuration = (serviceId: string, services: any[]) => {
  const service = services.find(s => (s.id || s._id) === serviceId);
  if (service) {
    if (service.duration) return service.duration;
    if (service.title) {
      const parsed = parseInt(service.title, 10);
      if (!isNaN(parsed)) return parsed;
    }
  }
  return 60; // default 60 minutes
};

export const addMinutesToTime = (time: string, minutes: number) => {
  const [hoursRaw, minsRaw] = time.split(":");
  const hours = parseInt(hoursRaw, 10) || 0;
  const mins = parseInt(minsRaw, 10) || 0;
  const totalMinutes = hours * 60 + mins + Number(minutes || 0);
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMins = totalMinutes % 60;
  return `${String(newHours).padStart(2, "0")}:${String(newMins).padStart(2, "0")}`;
};

export const clampEndTime = (startTime: string, endTime: string, maxHours: number) => {
  const [startHRaw, startMRaw] = startTime.split(":");
  const [endHRaw, endMRaw] = endTime.split(":");
  const startH = parseInt(startHRaw, 10) || 0;
  const startM = parseInt(startMRaw, 10) || 0;
  const endH = parseInt(endHRaw, 10) || 0;
  const endM = parseInt(endMRaw, 10) || 0;
  const startTotal = startH * 60 + startM;
  const endTotal = endH * 60 + endM;
  const maxTotal = startTotal + maxHours * 60;
  if (endTotal > maxTotal) {
    const clampedTotal = maxTotal;
    const clampedH = Math.floor(clampedTotal / 60) % 24;
    const clampedM = clampedTotal % 60;
    return `${String(clampedH).padStart(2, "0")}:${String(clampedM).padStart(2, "0")}`;
  }
  return endTime;
};
